/* 🤖 this file was generated by svg-to-ts */
export const siriusStamp: {
  name: 'stamp';
  data: string;
} = {
  name: 'stamp',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="m14.428 12 1.474-6.875A3 3 0 0 0 12.965 1.5h-1.93a3 3 0 0 0-2.937 3.625L9.572 12H4.5A1.5 1.5 0 0 0 3 13.5v3.75a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5V13.5a1.5 1.5 0 0 0-1.5-1.5h-5.072Zm-3.394-9a1.5 1.5 0 0 0-1.47 1.812L11.107 12h1.788l1.541-7.188A1.501 1.501 0 0 0 12.967 3h-1.933ZM19.5 13.5v3.75h-15V13.5h15Z" fill="currentColor"/><path d="M3 21a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 21Z" fill="currentColor"/></svg>`
};
